import { useConversations } from '../../../conversations/src/features/overview/api/getConversations';

const useLastCompletedConversation = (partyId?: string) => {
  const { data: conversations, isLoading } = useConversations({
    partyId,
    filters: {
      status: 'COMPLETED',
    },
  });
  return { data: conversations?.items[0], isLoading };
};

export default useLastCompletedConversation;
